import React from 'react'
import { useEscapeKey } from 'components/hooks/useEscapeKey'
import { ModalCloseButton } from 'components/common/modal/ModalCloseButton'

interface IssueWarningModalProps {
  actions: React.ReactNode
  children: React.ReactNode
  error?: string | null
  messageWrapperClassName?: string
  testId: string
  title: string
  titleId: string
  onCancel: () => void
}

export const IssueWarningModal: React.FC<IssueWarningModalProps> = ({
  actions,
  children,
  error = null,
  messageWrapperClassName = '',
  testId,
  title,
  titleId,
  onCancel
}) => {
  useEscapeKey(onCancel)

  return (
    <div
      className='message-reviewer-modal-overlay canary-issue-modal__leave-warning-overlay'
      data-testid={testId}
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel()
      }}
    >
      <div
        className='canary-issue-modal__leave-warning'
        role='dialog'
        aria-modal='true'
        aria-labelledby={titleId}
      >
        <ModalCloseButton onClick={onCancel} />

        <div className='canary-issue-modal__leave-warning-content'>
          <h2
            id={titleId}
            className='canary-issue-modal__leave-warning-title'
          >
            {title}
          </h2>

          <div className={`canary-issue-modal__leave-warning-message-wrapper ${messageWrapperClassName}`.trim()}>
            <i
              className='fa-regular fa-triangle-exclamation canary-issue-modal__leave-warning-icon'
              aria-hidden='true'
            />
            {children}
          </div>

          {error != null && (
            <p role='alert' className='canary-issue-modal__error'>
              {error}
            </p>
          )}

          <div className='canary-issue-modal__leave-warning-actions'>
            {actions}
          </div>
        </div>
      </div>
    </div>
  )
}
